"use strict";

import * as moment from "moment";
import {IQService} from "angular";
import {catchError, map} from "rxjs/operators";
import {Observable} from "rxjs";

export class CacheService {

    public static $inject = ["$q", "LocalForage"];
    public constructor(
        protected $q:IQService,
        protected LocalForage:any
    ) {
    }

    /**
     * @param object
     * @returns {boolean}
     */
    protected isExpired(object:any) {
        if (object == null) {
            return false;
        }

        let now = moment.utc().format("X");
        let expires = object.expires;

        return now > expires;
    }

    /**
     * @param key
     * @param item
     * @returns {any}
     */
    protected getItemContent(key:any, item:any) {
        if (item !== null && item.hasOwnProperty("newValue")) {
            item = item.newValue;
        }

        if (item !== null && item.content !== null && !this.isExpired(item)) {
            return item.content;
        }

        if (this.isExpired(item)) {
            this.removeItem(key);
        }

        return null;
    }

    /**
     * @param key
     * @returns {Observable<any>}
     */
    public getObservable(key): Observable<any> {
        return this.LocalForage.newObservable({
            key: key,
            setItem: true,
            removeItem: false,
            clear: false,
            changeDetection: false,
        }).pipe(
            map((item:any) => {
                return this.getItemContent(key, item);
            }),
            catchError(() => [])
        );
    }

    /**
     * @param key
     * @returns {Promise<any>}
     */
    public getItem(key:any) {
        return this.LocalForage.getItem(key).then((item:any) => {
            let itemContent = this.getItemContent(key, item);

            return itemContent || this.$q.reject(null);
        });
    }

    /**
     * @param key
     * @param value
     * @param timeout
     * @returns {Promise<any>}
     */
    public setItem(key, value, timeout = null) {
        timeout = timeout || moment.utc().add(10, "minutes");
        timeout = timeout.format("X");

        let item = {
            expires: timeout,
            content: value
        };

        return this.LocalForage.setItem(key, item)
            .catch(() => value)
            .then(() => value);
    }

    /**
     * @param key
     * @returns {void}
     */
    public removeItem(key) {
        this.LocalForage.removeItem(key).catch(x => x);
    }

    /**
     * Cleans up the expired caches
     */
    public cleanUp() {
        this.LocalForage.iterate((item:any, key) => {
            if (item === null || this.isExpired(item) || item.content === null) {
                this.removeItem(key);
                console.log(key, "has been cleared");
            }
        }).catch(x => x);
    }
}